import React from "react";
import type { User } from '@/shared/types';
import { useNavigate } from "react-router-dom";
import { AUTH, type AuthState } from "@/shared/constants/auth";
function AppItem({
    user,
    setAuthState,
    title,
    description,
    navigation
}:{
    user: User | null, 
    setAuthState: (state: AuthState) => void,
    title: string, 
    description: string, 
    navigation: string,
    }
){
    const navigate = useNavigate();

    return(
        <div className='appItem'>
            <div></div>
            <div className='appInfo'>
                <div>
                    <div className='fs-12 fw-600'>GHArcade</div>
                    <div>{title}</div>
                    <div className='fs-12 fw-600' style={{ color: "rgba(236,240,241, .7)"}}>{description}</div>
                </div>
                <button className='homePlayButton' onClick={() => user ? navigate(`${navigation}`) : setAuthState(AUTH.LOGIN)}>Play</button>
            </div>
        </div>
    )
}
export default AppItem